// assets/ritual-mega-menu.js
(() => {
  if (window.__ritualMegaMenuInit) return;
  window.__ritualMegaMenuInit = true;

  // CUSTOM START Karpio - Drawer scroll lock without body fixed
  let rdmm2IsScrollLocked = false;
  let rdmm2SavedHtmlOverflow = '';
  let rdmm2SavedBodyOverflow = '';
  let rdmm2SavedHtmlOverscroll = '';
  let rdmm2SavedBodyOverscroll = '';

  const getOpenRoot = () => {
    return document
      .querySelector('[data-rdmm2-root] [data-panel]:not([hidden])')
      ?.closest('[data-rdmm2-root]');
  };

  const getOpenPanel = () => {
    return document.querySelector('[data-rdmm2-root] [data-panel]:not([hidden])');
  };

  const preventScrollOutsideDrawer = (event) => {
    if (!rdmm2IsScrollLocked) return;

    const panel = getOpenPanel();

    if (!panel) {
      event.preventDefault();
      return;
    }

    if (panel.contains(event.target)) {
      return;
    }

    event.preventDefault();
  };

  const lockPageScroll = () => {
    if (rdmm2IsScrollLocked) return;

    rdmm2IsScrollLocked = true;

    rdmm2SavedHtmlOverflow = document.documentElement.style.overflow;
    rdmm2SavedBodyOverflow = document.body.style.overflow;
    rdmm2SavedHtmlOverscroll = document.documentElement.style.overscrollBehavior;
    rdmm2SavedBodyOverscroll = document.body.style.overscrollBehavior;

    document.documentElement.classList.add('rdmm2-open');
    document.body.classList.add('rdmm2-open');

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overscrollBehavior = 'none';

    document.addEventListener('wheel', preventScrollOutsideDrawer, { passive: false });
    document.addEventListener('touchmove', preventScrollOutsideDrawer, { passive: false });
  };

  const unlockPageScroll = () => {
    if (!rdmm2IsScrollLocked) return;

    rdmm2IsScrollLocked = false;

    document.removeEventListener('wheel', preventScrollOutsideDrawer, { passive: false });
    document.removeEventListener('touchmove', preventScrollOutsideDrawer, { passive: false });

    document.documentElement.classList.remove('rdmm2-open');
    document.body.classList.remove('rdmm2-open');

    document.documentElement.style.overflow = rdmm2SavedHtmlOverflow;
    document.body.style.overflow = rdmm2SavedBodyOverflow;
    document.documentElement.style.overscrollBehavior = rdmm2SavedHtmlOverscroll;
    document.body.style.overscrollBehavior = rdmm2SavedBodyOverscroll;
  };
  // CUSTOM END Karpio - Drawer scroll lock without body fixed

  const openRoot = (root) => {
    const panel = root.querySelector('[data-panel]');
    const overlay = root.querySelector('[data-overlay]');
    const openBtn = root.querySelector('[data-open]');
    const tilesGrid = root.querySelector('[data-tiles]');
    const hint = root.querySelector('[data-hint]');
    const l1Links = root.querySelectorAll('[data-l1]');

    if (panel) panel.hidden = false;
    if (overlay) overlay.hidden = false;

    // CUSTOM START Karpio - Lock page scroll when drawer opens
    lockPageScroll();
    // CUSTOM END Karpio - Lock page scroll when drawer opens

    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');

    if (hint) hint.style.display = '';

    l1Links.forEach((a) => a.setAttribute('aria-current', 'false'));

    const first = l1Links && l1Links[0];

    if (first) {
      const handle = first.getAttribute('data-handle');

      if (handle) {
        showTiles(root, handle, (first.textContent || '').trim(), true);
      }
    } else if (tilesGrid) {
      // Keep prefilled Liquid tiles if no technical nav exists.
    }
  };

  const closeRoot = (root) => {
    const panel = root.querySelector('[data-panel]');
    const overlay = root.querySelector('[data-overlay]');
    const openBtn = root.querySelector('[data-open]');
    const hint = root.querySelector('[data-hint]');
    const l1Links = root.querySelectorAll('[data-l1]');

    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (hint) hint.style.display = '';

    l1Links.forEach((a) => a.setAttribute('aria-current', 'false'));

    window.setTimeout(() => {
      if (panel) panel.hidden = true;
      if (overlay) overlay.hidden = true;

      // CUSTOM START Karpio - Unlock page scroll when drawer closes
      unlockPageScroll();
      // CUSTOM END Karpio - Unlock page scroll when drawer closes

      if (openBtn) openBtn.focus?.();
    }, 220);
  };

  const showTiles = (root, handle, title, silent) => {
    const tpl = root.querySelector(`template[data-tpl="${CSS.escape(handle)}"]`);
    const tilesGrid = root.querySelector('[data-tiles]');
    const hint = root.querySelector('[data-hint]');
    const l1Links = root.querySelectorAll('[data-l1]');

    if (!tpl || !tilesGrid) return;

    tilesGrid.innerHTML = '';
    tilesGrid.appendChild(tpl.content.cloneNode(true));

    if (hint) hint.style.display = 'none';

    l1Links.forEach((a) => a.setAttribute('aria-current', 'false'));

    const active = root.querySelector(`[data-l1][data-handle="${CSS.escape(handle)}"]`);

    if (active) {
      active.setAttribute('aria-current', 'true');
    }

    if (!silent) {
      // Optional hook for future title display.
    }
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-open]');

    if (openBtn) {
      const root = openBtn.closest('[data-rdmm2-root]');
      if (!root) return;

      event.preventDefault();

      const panel = root.querySelector('[data-panel]');
      const isOpen = panel && !panel.hidden;

      if (isOpen) {
        closeRoot(root);
      } else {
        openRoot(root);
      }

      return;
    }

    const closeBtn = event.target.closest('[data-close]');

    if (closeBtn) {
      const root = closeBtn.closest('[data-rdmm2-root]');
      if (!root) return;

      event.preventDefault();
      closeRoot(root);
      return;
    }

    const overlay = event.target.closest('[data-overlay]');

    if (overlay) {
      const root = overlay.closest('[data-rdmm2-root]');
      if (!root) return;

      event.preventDefault();
      closeRoot(root);
      return;
    }

    const l1 = event.target.closest('[data-l1]');

    if (l1) {
      const root = l1.closest('[data-rdmm2-root]');
      if (!root) return;

      const handle = l1.getAttribute('data-handle');
      if (!handle) return;

      event.preventDefault();
      showTiles(root, handle, (l1.textContent || '').trim());
      return;
    }

    if (document.body.classList.contains('rdmm2-open')) {
      const openRoot = getOpenRoot();

      if (openRoot) {
        const clickedInsidePanel = event.target.closest('[data-panel]');
        const clickedToggle = event.target.closest('[data-open]');

        if (!clickedInsidePanel && !clickedToggle) {
          event.preventDefault();
          closeRoot(openRoot);
          return;
        }
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!document.body.classList.contains('rdmm2-open')) return;

    const root = getOpenRoot();

    if (root) {
      closeRoot(root);
    }
  });
})();